import { useSelector } from 'react-redux'

import {
  selectShouldFetch,
  selectKpiVariableOptions
} from 'redux/selectors/KpiVariableOptions'

/**
 * Hook for all kpi variable options
 * @returns [kpi variable options, loading]
 */
export const useKpiVariableOptions = () => {
  return useSelector(selectKpiVariableOptions)
}

/**
 * Hook to check if variable options are fetched
 * @returns fetched
 */
export const useShouldFetchKpiVariableOptions = () => {
  return useSelector(selectShouldFetch)
}
